// removed by extract-text-webpack-plugin
module.exports = {"menu":"PWr0V","item":"_3ukG9","active":"_2g_FF","panel":"_1yuN0","badge":"_1yoDi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TabView/TabView.scss
// module id = ./src/components/TabView/TabView.scss
// module chunks = 5